module.exports = __webpack_public_path__ + "static/media/RemeraPinamar.9cf59c0d.webp";